// packages
import { onMounted, onUnmounted } from '@vue/composition-api';

/**
 * [method]
 * Validação se o click é fora do elemento, de forma
 * a fechar o conteúdo desse elemento.
 *
 * @param {String} elementClass
 * @param {Boolean} condition
 * @param {Function} toggle
 * @since 1.0.0
 * @category Method
 * @autor Tiago Martinho
 *
*/
export default function ({ elementClass, condition, toggle }) {
    const handlerClickOutside = event => {
        // Se o target do click for filho do elemento pai
        // e se a condição for verdadeira, então será dado o toggle do conteúdo.
        if (
            !document.querySelector( `.${elementClass}` ).contains( event.target )
            && condition.value
        )
            toggle();
    };

    // adicionado o evento a DOM.
    onMounted( () => {
        document.addEventListener( 'click', handlerClickOutside );
    });

    // removido o evento da DOM, quando o elemento é destruído.
    onUnmounted( () => {
        document.removeEventListener( 'click', handlerClickOutside );
    });
}